import React from 'react';
import ProjectsData from '../Data/ProjectsData';
import Description from './Description';
import Hexagon from './Hexagon';

function Projects() {
    return (
        <section className="projects">
            <Hexagon
                ID="1"
                position="Left"
                name={ProjectsData[0]["name"]}
                mainTech={ProjectsData[0]["mainTech"]}
                link={ProjectsData[0]["link"]}
            />

            <Description
                ID="1"
                text={ProjectsData[0]["description"]["text"]}
                technologies={ProjectsData[0]["description"]["technologies"]}
            />

            <Description
                ID="2"
                text={ProjectsData[1]["description"]["text"]}
                technologies={ProjectsData[1]["description"]["technologies"]}
            />

            <Hexagon
                ID="2"
                position="Right"
                name={ProjectsData[1]["name"]}
                mainTech={ProjectsData[1]["mainTech"]}
                link={ProjectsData[1]["link"]}
            />

            <Hexagon
                ID="3"
                position="Left"
                name={ProjectsData[2]["name"]}
                mainTech={ProjectsData[2]["mainTech"]}
                link={ProjectsData[2]["link"]}
            />

            <Description
                ID="3"
                text={ProjectsData[2]["description"]["text"]}
                technologies={ProjectsData[2]["description"]["technologies"]}
            />

            <Description
                ID="4"
                text={ProjectsData[3]["description"]["text"]}
                technologies={ProjectsData[3]["description"]["technologies"]}
            />

            <Hexagon
                ID="4"
                position="Right"
                name={ProjectsData[3]["name"]}
                mainTech={ProjectsData[3]["mainTech"]}
                link={ProjectsData[3]["link"]}
            />
        </section>
    );
}

export default Projects



// WEBPACK FOOTER //
// ./src/Components/Projects/JavaScript/Projects.js